import { addToRecord, arrayWithoutSubset } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { ThreadLoadNewerRepliesFulfilledAction } from '../../domains/threadLoad/actions.types';
import { TypingIndicatorsBegan, TypingIndicatorsFinished } from '../../domains/typingIndicators/actions.types';

import { TypingIndicators } from './types';

const initialState = {};

export type TypingIndicatorsAction =
  | TypingIndicatorsBegan
  | TypingIndicatorsFinished
  | ThreadLoadNewerRepliesFulfilledAction;

const addUserToTypers = (state: TypingIndicators, payload: TypingIndicatorsBegan['payload']) => {
  const { userId, threadId } = payload;
  const currentTypers = state[threadId] || [];

  const isUserAlreadyTyping = currentTypers.indexOf(userId) > -1;
  if (isUserAlreadyTyping) {
    return state;
  }

  const typersWithUser = [...currentTypers, userId];

  return addToRecord(state, threadId, typersWithUser);
};

const removeUsersFromTypers = (state: TypingIndicators, payload: TypingIndicatorsFinished['payload']) => {
  const { userIds, threadId } = payload;
  const currentTypers = state[threadId];

  if (!currentTypers) {
    return state;
  }

  const typersWithoutUser = arrayWithoutSubset(currentTypers, userIds);

  return addToRecord(state, threadId, typersWithoutUser);
};

const removeLastReplySenderFromTypers = (
  state: TypingIndicators,
  { id: threadId, entities }: ThreadLoadNewerRepliesFulfilledAction['payload']
) => {
  const currentTypers = state[threadId];
  const messages = entities.messages;

  if (!currentTypers || !messages) {
    return state;
  }

  const replies = entities.threads[threadId].replyEdges;

  if (replies.length === 0) {
    return state;
  }

  const lastReplyId = replies[replies.length - 1].nodeId;
  const lastSenderId = messages[lastReplyId].sender.id;

  const typersWithoutLastReplier = arrayWithoutSubset(currentTypers, [lastSenderId]);

  return addToRecord(state, threadId, typersWithoutLastReplier);
};

const reducer: Reducer<TypingIndicators, TypingIndicatorsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TYPING_INDICATORS.TYPING_BEGAN': {
      return addUserToTypers(state, action.payload);
    }
    case 'TYPING_INDICATORS.TYPING_FINISHED': {
      return removeUsersFromTypers(state, action.payload);
    }
    case 'THREAD.LOAD_NEWER_REPLIES_FULFILLED': {
      return removeLastReplySenderFromTypers(state, action.payload);
    }
    default:
      return state;
  }
};

export default reducer;
